module.exports = __webpack_public_path__ + "Support-icon.12af2c8.png";